const AUTH_PAGES = new Set(['/login', '/register', '/change-password', '/forgot-password', '/reset-password']);

export function isAuthPage(pathname: string) {
  return AUTH_PAGES.has(pathname);
}

export function getCurrentPathWithSearchAndHash() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function getSafeReturnToPath(returnTo: string | null | undefined): string | null {
  if (!returnTo) return null;
  if (!returnTo.startsWith('/')) return null;
  if (returnTo.startsWith('//')) return null;

  const [pathname] = returnTo.split(/[?#]/);
  if (!pathname || isAuthPage(pathname)) return null;

  return returnTo;
}

export function buildLoginUrl(returnTo?: string) {
  const safeReturnTo = getSafeReturnToPath(returnTo);
  if (!safeReturnTo) return '/login';

  const params = new URLSearchParams();
  params.set('returnTo', safeReturnTo);

  return `/login?${params.toString()}`;
}
